import React from "react";
import { Package, Printer } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import PackerLineItem from "./PackerLineItem";
import type { PackerOrder } from "@/hooks/usePackers";

interface PackerOrderCardProps {
  order: PackerOrder;
  selected: boolean;
  onToggleSelect: (ordernumber: string) => void;
  onMarkPacked: (ordernumber: string) => void;
  onPrintLabel: (ordernumber: string) => void;
  isPacking: boolean;
  isPrintingLabel: boolean;
}

const PackerOrderCard = ({ order, selected, onToggleSelect, onMarkPacked, onPrintLabel, isPacking, isPrintingLabel }: PackerOrderCardProps) => {
  return (
    <div
      className={`rounded-xl p-4 transition-colors ${
        order.is_future_shipping
          ? 'bg-white/5 border-2 border-red-500/50'
          : 'bg-white/5 border border-white/10'
      }`}
    >
      {/* Header */}
      <div className="flex items-center gap-3 mb-3">
        <Checkbox
          checked={selected}
          onCheckedChange={() => onToggleSelect(order.ordernumber)}
          className="border-white/30 data-[state=checked]:bg-blue-500 data-[state=checked]:border-blue-500"
        />
        <span className="text-white font-bold text-base">{order.ordernumber}</span>
        {order.customer?.city && (
          <span className="bg-white/10 text-white/70 px-2 py-0.5 rounded text-xs">
            {order.customer.city}
          </span>
        )}
        <span className="bg-white/10 text-white/60 px-2 py-0.5 rounded text-xs">
          {order.item_count} items
        </span>
        {order.is_printed && (
          <span className="bg-emerald-500/20 text-emerald-300 px-2 py-0.5 rounded text-xs">
            Afgedrukt
          </span>
        )}
        <div className="ml-auto flex items-center gap-1.5">
          <Button
            size="sm"
            variant="outline"
            onClick={() => onPrintLabel(order.ordernumber)}
            disabled={isPrintingLabel}
            className="bg-white/10 border-white/20 text-white hover:bg-white/20 h-8"
          >
            <Printer className="w-3.5 h-3.5 mr-1" />
            Label
          </Button>
          <Button
            size="sm"
            onClick={() => onMarkPacked(order.ordernumber)}
            disabled={isPacking}
            className="bg-emerald-600 hover:bg-emerald-700 text-white h-8"
          >
            <Package className="w-3.5 h-3.5 mr-1" />
            Inpakken
          </Button>
        </div>
      </div>

      {/* Line items */}
      <div className="pl-8">
        {order.line_items.map((item, idx) => (
          <PackerLineItem key={idx} item={item} />
        ))}
      </div>
    </div>
  );
};

export default PackerOrderCard;
